import type { LegalEntity } from "../types/legalEntity";

export const mockLegalEntities: LegalEntity[] = [
  {
    id: "le-001",
    entityName: "TMHCC Insurance Holdings LLC",
    name: "Emily Davis",
    title: "VP Legal",
    company: "TMHCC Insurance Holdings LLC",
    streetAddress: "1 Manhattan Blvd",
    city: "Purchase",
    state: "NY",
    zip: "10577",
    phone: "+1 914-555-0101",
    email: "emily.davis@example.com",
    address: "1 Manhattan Blvd, Purchase, NY 10577",
    createdBy: "Emily Davis (emily.davis@example.com)",
    createdOn: "04-30-2021",
    modifiedBy: "John Smith (john.smith@example.com)",
    status: "Active"
  },
  {
    id: "le-002",
    entityName: "Tokio Marine North America Inc",
    name: "Sarah Johnson",
    title: "Legal Counsel",
    company: "Tokio Marine North America Inc",
    streetAddress: "1221 Avenue of the Americas",
    city: "New York",
    state: "NY",
    zip: "10020",
    phone: "+1 212-555-0102",
    email: "sarah.johnson@example.com",
    address: "1221 Avenue of the Americas, New York, NY 10020",
    createdBy: "Sarah Johnson (sarah.johnson@example.com)",
    createdOn: "08-15-2020",
    modifiedBy: "Michael Chen (michael.chen@example.com)",
    status: "Active"
  },
  {
    id: "le-003",
    entityName: "Philadelphia Insurance Companies",
    name: "John Smith",
    title: "Director",
    company: "Philadelphia Insurance Companies",
    streetAddress: "One Bala Plaza",
    city: "Albany",
    state: "NY",
    zip: "12207",
    phone: "+1 518-555-0199",
    email: "john.smith@example.com",
    address: "One Bala Plaza, Albany, NY 12207",
    createdBy: "Emily Davis (emily.davis@example.com)",
    createdOn: "01-10-2022",
    modifiedBy: "John Smith (john.smith@example.com)",
    status: "Active"
  },
  {
    id: "le-004",
    entityName: "Tokio Marine HCC",
    name: "Michael Chen",
    title: "AVP",
    company: "Tokio Marine HCC",
    streetAddress: "13403 Northwest Freeway",
    city: "Houston",
    state: "TX",
    zip: "77040",
    phone: "+1 713-555-0170",
    email: "michael.chen@example.com",
    address: "13403 Northwest Freeway, Houston, TX 77040",
    createdBy: "Sarah Johnson (sarah.johnson@example.com)",
    createdOn: "11-22-2019",
    modifiedBy: "Michael Chen (michael.chen@example.com)",
    status: "Inactive"
  },
  {
    id: "le-005",
    entityName: "First Insurance Company",
    name: "Robert Wilson",
    title: "Manager",
    company: "First Insurance Company",
    streetAddress: "100 Insurance Way",
    city: "Dallas",
    state: "TX",
    zip: "75201",
    phone: "+1 972-555-0140",
    email: "robert.wilson@example.com",
    address: "100 Insurance Way, Dallas, TX 75201",
    createdBy: "Robert Wilson (robert.wilson@example.com)",
    createdOn: "05-12-2023",
    modifiedBy: "Robert Wilson (robert.wilson@example.com)",
    status: "Active"
  },
  {
    id: "le-006",
    entityName: "Pacific Reinsurance Corp",
    name: "Ava Williams",
    title: "Senior Counsel",
    company: "Pacific Reinsurance Corp",
    streetAddress: "500 Pacific Ave",
    city: "San Francisco",
    state: "CA",
    zip: "94102",
    phone: "+1 415-555-0118",
    email: "ava.williams@example.com",
    address: "500 Pacific Ave, San Francisco, CA 94102",
    createdBy: "Emily Davis (emily.davis@example.com)",
    createdOn: "09-08-2022",
    modifiedBy: "Sarah Johnson (sarah.johnson@example.com)",
    status: "Active"
  }
];
